const clampProgress = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;
  return Math.min(100, Math.max(0, Math.round(numericValue)));
};

export default function UploadProgressRing({ progress = 0 }) {
  const normalizedProgress = clampProgress(progress);
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const dashOffset =
    circumference - (normalizedProgress / 100) * circumference;

  return (
    <div className="relative size-14">
      <svg className="relative size-full -rotate-90" viewBox="0 0 48 48">
        <circle
          cx="24"
          cy="24"
          r={radius}
          strokeWidth="4"
          className="fill-none stroke-white/20"
        />
        <circle
          cx="24"
          cy="24"
          r={radius}
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          className="fill-none stroke-white transition-[stroke-dashoffset] duration-300 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold text-white tabular-nums">
        {normalizedProgress}%
      </div>
    </div>
  );
}
